import CryptoJS from 'crypto-js'


const SECRET_KEY = '3qwYA!0ezc4pi%Y0'

const SECRET_IV = '7%!19B11hKwCn#hu'

export function encryptPwd(password) {
    return CryptoJS.AES.encrypt(
        password,
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        {
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            iv: CryptoJS.enc.Utf8.parse(SECRET_IV)
        }
    ).toString();
}

/**
 * 解密密码
 * @param {string} ciphertext - 加密后的字符串
 * @returns {string} - 解密后的原始字符串
 */
export function decryptPwd(ciphertext) {
    if (!ciphertext) {
        return '';
    }
    try {
        const bytes = CryptoJS.AES.decrypt(
            ciphertext,
            CryptoJS.enc.Utf8.parse(SECRET_KEY),
            {
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                iv: CryptoJS.enc.Utf8.parse(SECRET_IV)
            }
        );

        // 将解密后的字节转换为 UTF-8 字符串
        const originalText = bytes.toString(CryptoJS.enc.Utf8);

        // 如果解密失败或结果为空，可能返回空字符串
        if (!originalText) {
            console.warn('Decrypt result is empty');
            return '';
        }

        return originalText;
    } catch (error) {
        console.error('Decryption failed:', error);
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/utils/crypto.js